import { ROTATE_CLOCKWISE } from './types';

export const rotate = pageIndex => (dispatch) => {
  dispatch({
    type: ROTATE_CLOCKWISE,
    payload: {
      pageIndex,
    },
  });
};
